import api from "../../api";
import publicApi from "../../checkout/publicApi";

export const getVenues = async (data : any) => {

    const res = await api.get("venues/", { params : data })
    return res.data
}

export const getVenuesForMap = async (data : any) => {
    const res = await api.get("venues/map/", { params : data })
    return res.data
}

export const getDetailVenueForMobile = async (id : string) => {
    const res = await api.get(`venues/map/${id}/`)
    return res.data
}

export const getCoachList = async (data : {
    search ?: string,
    page ?: number,
    page_size ?: number,
    fields?: string[],
    is_coach ?: boolean,
    is_host ?: boolean,
}) => {

    const res = await api.get("member/", { params : {...data, include_self : true, fields : data.fields?.join(',') }})

    return res.data
}

export const getVenueDetail = async ({id} : {id : string | undefined}) => {

    const res = await api.get(`venues/${id}/`)
    return res.data
}

export const getVenueEvents = async ({id, filterParams} : {id : string | undefined, filterParams : {
    time? : string | null,
    date? : string | null,
    min_date ?: string | null,
    available_only : boolean,
    page : number,
    page_size : number,
}}) => {
    // if (filterParams.min_date === null) {
    //     delete filterParams.min_date;
    // }
    // if (filterParams.start_date === null) {
    //     delete filterParams.start_date;
    // }

    console.log(filterParams)
    const res = await api.get(`venues/${id}/events/`, { params : filterParams })
    return res.data
}

export const getEvent = async ({id} : { id : string | undefined}) => {
    
    const res = await api.get(`events/${id}/`)
    return res.data
}

export const patchEventCheckIn = async ({ event_id, member_id, checked_in }: { event_id: string; member_id: string; checked_in: boolean }) => {
    const res = await api.patch(`events/${event_id}/check-in/`, { member_id, checked_in })
    return res.data
}

export const getPublicEventNoAuth = async ({id} : { id : string | undefined}) => {
    // Public API call without authentication - for public event share pages
    const res = await publicApi.get(`events/${id}/`)
    return res.data
}